<template>
  <div>
    <a-card size="small" title="测试环境同步">
        <search @onSearchChange="handleSearch"></search>
        <a-alert class="mt20" :message="tips" type="success" />
        <div class="mt20">
            <label for="">目标环境：</label>
            <a-radio-group v-model="targetEnv" @change="getAppSumData">
                <a-radio v-for="item in envNames" :key="item.key" :value="item.key">{{item.key}}</a-radio>
            </a-radio-group>
            <a-button class="fr" type="primary" @click="coverSelect">覆盖选中</a-button>

        </div>
        <a-table :columns="columns" :data-source="tableData"  style="margin-top:20px;" 
            :pagination="false" :loading="tloading"  @change="handleTableChange" rowKey="id"
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:rowsType}">
        </a-table>
        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
    </a-card>


     
  </div>
</template>
<script>
import search from "./search.vue"
let pagination ={
    page:1,
    pageSize:10,
    total:0
};


export default {
    data() {
        return {
            columns:[
                {
                    title: "序号",
                    width: 50,
                    align: "center",
                    customRender: (text, record, index) => {
                        let { page, pageSize } = pagination;
                        return (Number(page) - 1) * Number(pageSize) + index + 1;
                    }
                },
                {
                    title: '版本',
                    dataIndex: 'version',
                    align: 'center',
                    width:50
                },
                {
                    title: '业务类型',
                    dataIndex: 'businesstype',
                    align: 'center',
                    ellipsis: true,
                    width:100
                },
                {
                    title: '业务全称',
                    dataIndex: 'businesstypename',
                    align: 'center',
                    ellipsis: true,
                    width:100
                },

            ],
            tableData:[],
            selectedRowKeys: [],
            rowsType:'checkbox',

            tloading:false,
            pagination,
            clientWidth:1200,
            ordercoloum:'total',
            orderstr:'desc',
            searchP:{},
            envList:[
                'pre',
                'uat',
                'pet',
                'fat',
                'sit',
                'sim',
                'dev',
            ],
            targetEnv:'',
           
            temp_record:{},
            colums_diff:[],
            data_diff:[],
            tips:'提示：以当前环境数据覆盖目标环境数据'
        };
    },
    computed:{
        envNames(){
            let c_env = this.C.Env;
            let temp_env_list = this.envList.filter(item => { return item != c_env });
            let result = []
            temp_env_list.forEach(item => {
                let t_i = {
                    name:c_env + '->' + item,
                    key:item
                }
                result.push(t_i)
            });
            return result
        }
    },
    methods: {
        onSelectChange(selectedRowKeys){
            this.selectedRowKeys = selectedRowKeys;
        },
        handleSearch(searchP){
            if(!this.targetEnv){
                this.targetEnv = this.envNames[0].key
            }
            this.searchP = searchP;
            this.pagination.page = 1
            this.getAppSumData();
        },
        handleTableChange(d,v,sorter) {
            if(sorter.order){
                this.ordercoloum = sorter.field ;
                this.orderstr = sorter.order.replace('end','');
            }
            else{
                this.ordercoloum = '';
                this.orderstr = '';
            }

            this.getAppSumData();
        },
        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },
        getAppSumData(){
            let that = this
            let queryType = that.searchP.extype == 'export' ? 'filemanager/exportQueryDiff' : "filemanager/importQueryDiff";
            that.tloading = true;
            let params = {
                ...that.searchP,
                targetenv:that.targetEnv,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: queryType,
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.tableData = result.list;
                    that.pagination.total = parseInt(result.totalRecords);
                    that.pagination.pageSize = parseInt(result.pageSize);
                    that.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        coverSelect(){
            console.log(this.selectedRowKeys)
            console.log(this.targetEnv)
            if(this.selectedRowKeys.length > 0){
                let that = this
                let queryType = that.searchP.extype == 'export' ? 'filemanager/exportConfigTransfer' : "filemanager/importConfigTransfer";
                that.tloading = true;
                let params = {
                    ids:that.selectedRowKeys.join(','),
                    targetenv:that.targetEnv,
                    urlparams:false
                };
                that.$store.dispatch({
                    type: queryType,
                    params:params
                }).then((res)=>{
                    if(res.status == 200 && res.data.success == '1'){
                        that.getAppSumData();
                    }
                    that.tloading = false;
                }).catch(() => {
                    that.tloading = false;

                });
            }
            else{
                this.message.warn('请选择需要覆盖的数据')
            }

        }
    },
    components:{
        search
    },
    mounted(){
    }
};
</script>
<style scoped>
    .span_red{
        color: #ff4d4f;
    }
    .span_yellow{
        color: #faad14;
    }
    .span_green{
        color: #52c41a;
    }

    .bk_yellow{
        background-color: #ff4d4f;
    }
</style>
